var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-skeleton"},[_c('div',{staticClass:"skeleton-header"},[_c('div',{staticClass:"avatar-circle"}),_c('div',{staticClass:"author-line"})]),_c('div',{staticClass:"skeleton-body"},[_c('div',{staticClass:"body-title"},[_c('div',{staticClass:"text-line-top"}),_c('div',{staticClass:"text-line-bottom"})]),_c('div',{staticClass:"body-image"})])])
}]

export { render, staticRenderFns }